import { brandPoints, voices } from '@/mocks/chaoyang';

export default function AboutSection() {
  return (
    <section id="guanyu" className="w-full scroll-mt-20 bg-accent-100/40">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="mb-2 text-sm font-medium text-accent-700">关于朝阳吃瓜</p>
            <h2 className="text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              让每一场全民围观，
              <span className="text-primary-600">都有迹可循</span>
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              朝阳吃瓜专注聚合朝阳吃瓜热门话题、朝阳吃瓜榜与朝阳吃瓜头条热议。我们相信，
              信息爆炸的时代更需要“看得清楚”的吃瓜方式——只呈现公开可查的讨论热度与来源，
              帮你快速判断此刻最值得围观的话题，也能从容加入朝阳吃瓜热议的讨论。
            </p>

            <div className="mt-8 grid gap-5 sm:grid-cols-1">
              {brandPoints.map((p) => (
                <div key={p.title} className="flex gap-4">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                    <i className={`${p.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-950">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-7">
            <div className="mb-5 flex items-center justify-between">
              <h3 className="text-lg font-bold text-foreground-950">围观群众的声音</h3>
              <span className="flex items-center gap-1 text-sm text-secondary-600">
                <i className="ri-star-fill"></i> 4.9
              </span>
            </div>
            <ul className="space-y-4">
              {voices.map((v) => (
                <li key={v.name} className="rounded-xl bg-background-100/80 p-4">
                  <p className="text-sm leading-relaxed text-foreground-700">“{v.content}”</p>
                  <div className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-200 text-foreground-800">
                      <i className="ri-user-smile-line"></i>
                    </span>
                    <span className="font-medium text-foreground-700">{v.name}</span>
                    <span>· {v.role}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}